import React from 'react';
import {Tooltip, Checkbox} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  switchContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 4,
    padding: '6px 14px',

    height: 38, // Match PeriodPicker button height
    backgroundColor: theme.palette.graphColors.themeDarkGray,
  },
  switchText: {
    marginLeft: 4,
    marginRight: 4,
    fontSize: 14,
  },
}));

const TotalsSwitch = ({
  intervalsMode,
  setShowCombinedRevenue,
  showCombinedRevenue,
  removeMargin,
  selectedBidder,
}) => {
  const classes = useStyles();

  if (selectedBidder === 'Combined data') return null;

  return (
    <Tooltip
      arrow
      title={
        intervalsMode === 1
          ? 'Show combined revenue'
          : 'Combined revenue is disabled for Deciles mode'
      }
    >
      <div className={classes.switchContainer} style={{marginLeft: removeMargin ? 0 : 16}}>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: intervalsMode === 1 ? 'pointer' : 'default',
          }}
        >
          <span style={{marginLeft: '8px'}}>Show combined revenue</span>
          <Checkbox
            disabled={intervalsMode !== 1}
            color={'primary'}
            checked={showCombinedRevenue}
            onChange={() => setShowCombinedRevenue(!showCombinedRevenue)}
          />
        </label>
      </div>
    </Tooltip>
  );
};

export default TotalsSwitch;
